import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslocoLoader, Translation } from '@jsverse/transloco';
import { map, shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);
  private cache = new Map<string, any>();

  getTranslation(lang: string) {
    const cached = this.cache.get(lang);
    if (cached) return cached;

    const req$ = this.http
      .get(`/assets/i18n/${lang}.json`, { responseType: 'text' })
      .pipe(
        map((raw) => {
          const text = raw.replace(/^\uFEFF/, '').trim(); // usuń BOM
          if (text.startsWith('<')) throw new Error(`HTML instead of JSON for ${lang}`);
          return JSON.parse(text) as Translation;
        }),
        shareReplay(1)
      );

    this.cache.set(lang, req$);
    return req$;
  }
}